import { useState } from "react";
import useApiFetcher from "../../../hooks/useApiFetcher";
import { useSearchParams } from "react-router-dom";

export default function Form() {
  const { apiFetcher } = useApiFetcher(); //custom hook for apifetching
  const [searchParams] = useSearchParams();
  const dealId = searchParams.get('deal');
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    feedback: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const resp = await apiFetcher("/int-feedback", "POST", { ...formData, dealershipId: dealId });
    setFormData({ name: "", email: "", feedback: "" });

  };

  return (
    <div className="max-w-sm mx-auto bg-white rounded-xl p-4 mt-10 border ">

      <form onSubmit={handleSubmit} className="space-y-4">

        <div className="flex gap-2 sm:flex-none">
          <div>
            <label className=" text-gray-700 text-[16px]">Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full mt-1 py-1 px-2 border border-gray-300 text-[16px] rounded-md focus:ring-2 focus:ring-blue-400 focus:outline-none"
              placeholder="Enter your name"
            />
          </div>

          <div>
            <label className=" text-gray-700 text-[16px]">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full mt-1 py-1 px-2 border border-gray-300 text-[16px] rounded-md focus:ring-2 focus:ring-blue-400 focus:outline-none"
              placeholder="Enter your email"
            />
          </div>
        </div>


        <div>
          <label className="block text-gray-700 text-[16px]">How may I help you?</label>
          <textarea
            name="feedback"
            value={formData.feedback}
            onChange={handleChange}
            required
            rows="4"
            className="w-full mt-1 py-1 px-2 border border-gray-300 text-[16px] rounded-md focus:ring-2 focus:ring-blue-400 focus:outline-none"
            placeholder="Write here..."
          ></textarea>
        </div>

        <button
          type="submit"
          className="w-full bg-blue-500 text-white text-[16px] py-2 rounded-md hover:bg-blue-600 transition duration-300"
        >
          Submit
        </button>
      </form>
    </div>
  );
}
